import shortLogoSupervisor from '../../media/logos/SVG/FELES_Superv_white.svg'
import shortLogoFacturador from '../../media/logos/SVG/FELES_Facturador_white.svg'
import whiteHomeIcon from '../../media/felsv/white_house_icon.svg'
import whiteTag from '../../media/felsv/white_invoice_icon.svg'
import whiteBill from '../../media/felsv/white_bill_icon.svg'
import WhiteUsers from '../../media/felsv/white_users_icon.svg'
import WhiteProducts from '../../media/felsv/white_product_icon.svg'
import WhiteSucursal from '../../media/felsv/white_building_icon.svg'
import Profile from '../../media/felsv/white_account_icon.svg'
import LogOut from '../../media/felsv/white_logout_icon.svg'
import WhitePuzzle from '../../media/felsv/WhiteOtrosDocuments.svg'
import WhiteSuscripcion from '../../media/felsv/WhiteSuscripcion.svg'
import DarkFilePlus from '../../media/felsv/white_puzzle_icon.svg'

import './sidebar.css'
import {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, NavLink, useHistory, useLocation} from 'react-router-dom'
import {State} from '../../reducers'
import {KEYS} from '../../constants/keysStorage'
import {changeDimensionsScreen, clearDataRedux} from '../../actions/userLogin.actions'
import {setActiveModuleDoc} from '../../actions/documentos/documentos.actions'
import { cerrarSesion } from '../../actions/general.actions'
import { Box, Divider, Menu, MenuItem, Typography } from '@mui/material'
import { PerfilUsuario } from '../../interfaces/perfil-usuario.interface'
import { changeSucursalSeleccionada } from '../../actions/perfil/profile.actions'
import ModalConfirm from '../../components/Modals/Generales/ModalConfirm'
import { facturacionClearAll } from '../../actions/facturacion/facturacionEmision.actions'
import { handleRestarFlujo } from '../../actions/credito-fiscal.actions'

export const SideBar = (props: any) => {
  const {children} = props;

  const width: number = useSelector((state: State) => state.userLogin.width)!
  const emisor = useSelector((state: State) => state.catalogos.datosEmisor)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const profileData: PerfilUsuario = useSelector((state: State) => state.gestionUsuario.perfilUsuario)
  
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const [isOpenNavResponsive, setIsOpenNavResponsive] = useState(false);
  const [supervisor, setSupervisor] = useState(false)
  const [truncatedName, setTruncatedName] = useState<string | null>(null);

  const [sucursalChangeSelected, setSucursalChangeSelected] = useState<any>({});
  const [modalConfirmSucursal, setModalConfirmSucursal] = useState<boolean>(false);
  const [anchorMenuSucursal, setAnchorSucursal] = useState<null | HTMLElement>(null);
  const openMenuSucursal = Boolean(anchorMenuSucursal);

  const clearStorage = () => {
    cerrarSesion()
    dispatch(clearDataRedux())
    history.push('/')
  }

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })

  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }

  const sucursalSeleccionada = useMemo(() => {
    const sucursal = profileData?.sucursales?.find((sucursal) => sucursal.sucursal_seleccionada)
    return sucursal ?? {};
  }, [profileData?.sucursales])

  useEffect(() => {
    let rol = localStorage.getItem(KEYS.ROL)?.toString() || '0'
    if (rol !== '1' && rol !== '2') return clearStorage()
    setSupervisor(rol === '2')

    dispatch(changeDimensionsScreen(dimensions.width))
    window.addEventListener('resize', handleResize, false)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const nameClient = localStorage.getItem('nameClient');
    setTruncatedName(handleSubstringNavLink(nameClient));
  }, []);

  useEffect(() => {
    if (dimensions.width > 990 && isOpenNavResponsive) setIsOpenNavResponsive(false)
    if (dimensions.width > 990 && width <= 990) dispatch(changeDimensionsScreen(dimensions.width))
    else if (dimensions.width <= 990 && width > 990)
      dispatch(changeDimensionsScreen(dimensions.width))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dimensions.width])

  const logout = async () => {
    closeBurger()
    clearStorage()
  }

  const closeBurger = () => setIsOpenNavResponsive(false)

  const navegarCreditoFiscal = () => {
    dispatch(setActiveModuleDoc({title: 'Comprobante crédito fiscal', idDoc: '03'}))
  }

  const navegarOtrosDocs = () => {
    dispatch(setActiveModuleDoc({title: '', idDoc: ''}))
  }

  const handleConfirmChangeSucursal = async (objSucursal: any) => {
    if (objSucursal.sucursal_seleccionada) return; // Ya es la sucursal seleccionada

    setSucursalChangeSelected(objSucursal);
    setAnchorSucursal(null);
    setModalConfirmSucursal(true);
  }

  const handleChangeSucursal = async () => {
    const {Sucursal, sucursal_idsucursal} = sucursalChangeSelected;
    setModalConfirmSucursal(false);
    
    // Limpiar documentos
    dispatch(facturacionClearAll()); // CF
    dispatch(handleRestarFlujo()); // CCF
  
    // Realizar cambio de sucursal
    await dispatch(changeSucursalSeleccionada({...Sucursal, id_sucursal: sucursal_idsucursal}, false));
   
    // Redireccionar a home
    window.location.href = '/'; 
  }

  const handleSubstringNavLink = (txtNavLink: string|any) => {
    if (txtNavLink) {
      let shortenedName = txtNavLink;
      if (shortenedName.length > 18) {
        shortenedName = shortenedName.substring(0, 18) + '...';
      }
      return (shortenedName);
    }
  }

  return (
    <section className='content-section wf-section'>
      {modalConfirmSucursal &&
        <ModalConfirm
          title = 'Cambio de sucursal activa'
          detail = 'Estás a punto de cambiar tu sucursal activa, todos los datos ingresados se perderán. ¿Deseas continuar?'
          closeModalConfirm = {() => setModalConfirmSucursal(false)}
          actionConfirm = {() => handleChangeSucursal()}
        />     
      }
      <div
        data-animation='default'
        data-collapse='medium'
        data-duration='400'
        data-easing='ease-in-out'
        data-easing2='ease-in-out'
        role='banner'
        className='navbar w-nav'
        style={{height: width > 990 ? '100vh' : isOpenNavResponsive ? '100%' : '80px'}}
      >
        <div className='navcontainer w-container'>
          <div className='navheader'>
            <Link to='/home' className='navbar-brand w-nav-brand'>
              <img
                src={supervisor ? shortLogoSupervisor : shortLogoFacturador}
                loading='lazy'
                width='203'
                alt='IT Profis logo'
                className='navbar-logo'
              />
            </Link>
            <div className='navbar-separator'></div>
          </div>
          {!isOpenNavResponsive && (
            <nav role='navigation' className='navmenu w-nav-menu'>
              <div>
                <span aria-current='page' className='navbar-text-role'>
                  <div className='text-navlink m' style={{maxWidth: '200px', whiteSpace: 'pre-wrap'}}>
                    {emisor?.nombre}
                  </div>
                </span>
                <div className='navbar-separator'></div>
                <div className='navbar-text-role'>
                  {handleSubstringNavLink(`Sucursal activa:`)}
                </div>
                <div className='navlink w-inline-block m'>
                  <img src={WhiteSucursal} loading='lazy' alt='Perfil' className='navlink-icon m' />
                  <div onClick={(e) => {
                      // Mostrar menu solo si tiene mas de dos sucursales asignadas
                      profileData?.sucursales?.length > 1 &&
                      setAnchorSucursal(e.currentTarget)
                    }}>
                    {handleSubstringNavLink(sucursalSeleccionada?.Sucursal?.nombre ?? '--')}
                  </div>
                  <Box>
                    <Menu
                      id="menu-appbar"
                      keepMounted
                      open={openMenuSucursal}
                      anchorEl={anchorMenuSucursal}
                      onClose={() => setAnchorSucursal(null)}
                    >
                      <MenuItem key={5} disabled={true}>
                        <Typography>Elegir sucursal:</Typography>
                      </MenuItem>
                      <Divider sx={{ my: 0.5 }} />
                      <div
                        style={{ overflowY: 'auto', maxHeight: '150px'}}
                        >
                          {
                            profileData?.sucursales?.filter(sucursal => !sucursal.sucursal_seleccionada)
                              .map((sucursal, i: number) => (
                                <MenuItem key={i} onClick={(e) => handleConfirmChangeSucursal(sucursal)}>
                                  <Typography>{sucursal.Sucursal?.nombre}</Typography>
                                </MenuItem>
                            ))
                          }               
                      </div>
                    </Menu>
                  </Box>
                </div>
                <div className='navbar-separator'></div>
                  <NavLink
                    to='/home'
                    aria-current='page'
                    className='navlink w-inline-block'
                    activeClassName='navlinkactive'
                  >
                    <img src={whiteHomeIcon} loading='lazy' alt='home' className='navlink-icon m' />
                    <div className='text-navlink m'>Inicio</div>
                  </NavLink>
                {
                  localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' &&
                  <>
                    <NavLink
                      to='/emitir-factura/formulario'
                      className={`navlink w-inline-block ${
                        location.pathname.includes('/emitir-factura/') ? 'navlinkactive' : ''
                      }`}
                    >
                      <img src={whiteTag} loading='lazy' alt='EmitirFact' className='navlink-icon m' />
                      <div className='text-navlink m'>Emitir factura</div>
                    </NavLink>
                    
                    <NavLink
                      to='/otros-documentos/credito-fiscal'
                      onClick={navegarCreditoFiscal}
                      className={`navlink w-inline-block ${
                        location.pathname.includes('/otros-documentos/') && idDoc === '03'
                          ? 'navlinkactive'
                          : ''
                      }`}
                    >
                      <img src={whiteTag} loading='lazy' alt='EmitirFact' className='navlink-icon m' />
                      <div className='text-navlink m'>Emitir crédito fiscal</div>
                    </NavLink>

                    <NavLink
                      to='/history-invoice'
                      className='navlink w-inline-block'
                      activeClassName='navlinkactive'
                    >
                      <img src={whiteBill} loading='lazy' alt='Historial' className='navlink-icon m' />
                      <div className='text-navlink m'>Historial de documentos</div>
                    </NavLink>

                    <NavLink
                      to='/otros-documentos'
                      className={`navlink w-inline-block ${
                        location.pathname.includes('/otros-documentos') && idDoc !== '03'
                          ? 'navlinkactive'
                          : ''
                      }`}
                      onClick={navegarOtrosDocs}
                    >
                      <img src={WhitePuzzle} loading='lazy' alt='OtrasOp' className='navlink-icon m' />
                      <div className='text-navlink m'>Otros documentos</div>
                    </NavLink>
                  </>
                }
                
                {supervisor && localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' && (
                  <NavLink
                    to='/gestion-usuarios'
                    className='navlink w-inline-block'
                    activeClassName='navlinkactive'
                  >
                    <img src={WhiteUsers} loading='lazy' alt='Historial' className='navlink-icon m' />
                    <div className='text-navlink m'>Gestión de usuarios</div>
                  </NavLink>
                )}
                {supervisor && localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' && (
                  <NavLink
                    to='/gestion-productos'
                    className='navlink w-inline-block'
                    activeClassName='navlinkactive'
                  >
                    <img src={WhiteProducts} loading='lazy' alt='Historial' className='navlink-icon m' />
                    <div className='text-navlink m'>Gestión de productos</div>
                  </NavLink>
                )}
                {
                  supervisor && localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' && (
                  <NavLink
                    to='/mas-opciones'
                    className={`navlink w-inline-block ${
                      location.pathname.includes('/mas-opciones')
                        ? 'navlinkactive'
                        : ''
                    }`}
                  >
                    <img src={DarkFilePlus} loading='lazy' alt='Historial' className='navlink-icon m' />
                    <div className='text-navlink m'>Más opciones</div>
                  </NavLink>
                )}
              </div>
              <div></div>
              <div className='navlinks'>                
                <NavLink
                  to='/user/profile'
                  className='navlink w-inline-block m'
                  activeClassName='navlinkactive'
                >
                  <img src={Profile} loading='lazy' alt='Perfil' className='navlink-icon m' />
                  <div>{truncatedName}</div>
                </NavLink>
                {supervisor && (
                  <NavLink
                    to='/suscripcion/info'
                    className='navlink w-inline-block m'
                    activeClassName='navlinkactive'
                  >
                    <img
                      src={WhiteSuscripcion}
                      loading='lazy'
                      alt='Suscripcion'
                      className='navlink-icon m'
                    />
                    <div>Suscripción</div>
                  </NavLink>
                )}
                <div className='navlink w-inline-block cursor-button m' onClick={logout}>
                  <img src={LogOut} loading='lazy' alt='Cerrar' className='navlink-icon' />
                  <div>Cerrar sesión</div>
                </div>
                <div className='navbar-text-version w-inline-block '>
                  2023. Sistema de Facturación. <br /> Versión 1.0.1
                </div>
              </div>
            </nav>
          )}
          {/* icono de hamburguesa */}
          <div
            className={`menu-button w-nav-button  ${isOpenNavResponsive ? 'w--open' : ''}`}
            onClick={() => setIsOpenNavResponsive(!isOpenNavResponsive)}
          >
            <div className='w-icon-nav-menu'></div>
          </div>
        </div>
        <NavbarResponsive
          open={isOpenNavResponsive}
          logout={logout}
          closeBurger={closeBurger}
          supervisor={supervisor}
          location={location}
          empresa={emisor?.nombre}
          idDoc={idDoc}
          navegarCreditoFiscal={navegarCreditoFiscal}
          navegarOtrosDocs={navegarOtrosDocs}
        />
      </div>
      <div className='w-layout-vflex page-content' style={{overflowY:'scroll'}}>{children}</div>
    </section>
  )
}

const NavbarResponsive = (props: any) => {
  return (
    <div
      className='w-nav-overlay'
      style={
        props.open ? {display: 'block', minHeight: '100vh', overflow: 'auto'} : {display: 'none'}
      }
    >
      <nav
        role='navigation'
        id='navbar-responsive-scroll'
        className={`navmenu w-nav-menu animate__animated ${
          props.open ? 'animate__slideInDown animate__fast' : ''
        }`}
        data-nav-menu-open=''
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          transform: 'translateY(0px) translateX(0px)',
          transition: 'transform 400ms ease 0s',
        }}
      >
        <span aria-current='page' className='navlink w-inline-block'>
          <div>{props.empresa}</div>
        </span>
        <NavLink
          to='/home'
          aria-current='page'
          className='navlink w-inline-block'
          activeClassName='navlinkactive'
          onClick={props.closeBurger}
        >
          <img src={whiteHomeIcon} loading='lazy' alt='home' className='navlink-icon m' />
          <div>Inicio</div>
        </NavLink>
        
        {
          localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' &&
            <>
              <NavLink
                to='/emitir-factura/formulario'
                className={`navlink w-inline-block ${
                  props.location.pathname.includes('/emitir-factura/') ? 'navlinkactive' : ''
                } none`}
                onClick={props.closeBurger}
              >
                <img src={whiteTag} loading='lazy' alt='EmitirFact' className='navlink-icon m' />
                <div className='m'>Emitir factura</div>
              </NavLink>
              <NavLink
                to='/otros-documentos/credito-fiscal'
                className={`navlink w-inline-block ${
                  props.location.pathname.includes('/otros-documentos/') && props.idDoc === '03'
                    ? 'navlinkactive'
                    : ''
                }`}
                onClick={() => {
                  props.navegarCreditoFiscal()
                  props.closeBurger()
                }}
              >
                <img src={whiteTag} loading='lazy' alt='EmitirFact' className='navlink-icon m' />
                <div className='m'>Emitir crédito fiscal</div>
              </NavLink>
              <NavLink
                to='/history-invoice'
                className='navlink w-inline-block'
                activeClassName='navlinkactive'
                onClick={props.closeBurger}
              >
                <img src={whiteBill} loading='lazy' alt='Historial' className='navlink-icon m' />
                <div className='m'>Historial de documentos</div>
              </NavLink>
              <NavLink
                to='/otros-documentos'
                className={`navlink w-inline-block ${
                  props.location.pathname.includes('/otros-documentos') && props.idDoc !== '03'
                    ? 'navlinkactive'
                    : ''
                }`}
                onClick={() => {
                  props.closeBurger()
                  props.navegarOtrosDocs()
                }}
              >
                <img src={WhitePuzzle} loading='lazy' alt='OtrasOp' className='navlink-icon m' />
                <div className='m'>Otros documentos</div>
              </NavLink>
            </>
        }
        {props.supervisor && localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' && (
          <NavLink
            to='/gestion-usuarios'
            className='navlink w-inline-block m'
            activeClassName='navlinkactive'
            onClick={props.closeBurger}
          >
            <img src={WhiteUsers} loading='lazy' alt='Gestion' className='navlink-icon m' />
            <div>Gestión de usuarios</div>
          </NavLink>
        )}
        {
            props.supervisor && localStorage.getItem(KEYS.LIMITAR_USO_FELES) !== 'true' && (
            <NavLink
              to='/mas-opciones'
              className={`navlink w-inline-block ${
                props.location.pathname.includes('/mas-opciones') ? 'navlinkactive' : ''
              }`}
            >
              <img src={DarkFilePlus} loading='lazy' alt='Historial' className='navlink-icon m' />
              <div className='text-navlink m'>Más opciones</div>
            </NavLink>
          )}
        <NavLink
          to='/user/profile'
          className='navlink w-inline-block m'
          activeClassName='navlinkactive'
          onClick={props.closeBurger}
        >
          <img src={Profile} loading='lazy' alt='Perfil' className='navlink-icon m' />
          <div>{localStorage.getItem('nameClient')}</div>
        </NavLink>
        {props.supervisor && (
          <NavLink
            to='/suscripcion/info'
            className='navlink w-inline-block m'
            activeClassName='navlinkactive'
            onClick={props.closeBurger}
          >
            <img src={WhiteSuscripcion} loading='lazy' alt='Suscripcion' className='navlink-icon m' />
            <div>Suscripción</div>
          </NavLink>
        )}
        <div className='navlink w-inline-block cursor-button m' onClick={props.logout}>
          <img src={LogOut} loading='lazy' alt='Cerrar' className='navlink-icon m' />
          <div>Cerrar sesión</div>
        </div>
        <div className='navlink w-inline-block navbar-text-version'>
          2023. Sistema de Facturación. <br /> Versión 1.0.1
        </div>
      </nav>
    </div>
  )
}
